import { validateEnv } from './validateEnv'

// MODE/DEV/PROD are Vite intrinsics rather than schema-managed variables, so they are
// read directly here. This file is the only place in src/ permitted to touch
// import.meta.env (enforced by the local/no-direct-env-access ESLint rule).
export const env = import.meta.env.MODE

const envVars = validateEnv(import.meta.env)

export const version = envVars.VITE_VERSION

export const auth0 = {
  domain: envVars.VITE_AUTH0_DOMAIN,
  clientId: envVars.VITE_AUTH0_CLIENT_ID,
}

export const irwin = {
  baseUrl: envVars.VITE_IRWIN_BASE_URL,
  appUrl: envVars.VITE_IRWIN_APP_URL,
}

export const factset = {
  baseUrl: envVars.VITE_FACTSET_BASE_URL,
  authDomain: envVars.VITE_FACTSET_AUTH_DOMAIN,
  authLogoutUrl: `https://${envVars.VITE_FACTSET_AUTH_DOMAIN}/logout?cleanIdpId=true`,
}

export const featureFlags = {
  baseUrl: envVars.VITE_FEATURE_FLAGS_BASE_URL,
  clientKey: envVars.VITE_FEATURE_FLAGS_KEY,
}

export const mui = { dataGridKey: envVars.VITE_MUI_DATAGRID_KEY }

export const aws = { geoplacesApiKey: envVars.VITE_GEOPLACES_API_KEY }
